import {
    defaultFilterBenefits,
    defaultProductBenefits,
    defaultAccompanied,
} from "./state";

/**
 * Mutación que lista los productos con beneficios.
 *
 * @param {*} state
 * @param value productos con beneficios
 * @author Brandon Torres
 */
export function listProductBenefits(state, value) {
    state.productBenefits = value.data;
}

/**
 * Mutación que lista el contador los productos con beneficios.
 *
 * @param {*} state
 * @param value contador de productos con beneficios
 * @author Brandon Torres
 */
export function updateChart(state, value) {
    state.accompanied = value.count;
}

/**
 * Mutación para limpiar el buscador de la lista de los productos con beneficios.
 *
 * @param {*} state
 * @author Brandon Torres
 */
export function resetFilterBenefits(state) {
    Object.assign(state.filterBenefits, defaultFilterBenefits());
    state.productBenefits = defaultProductBenefits();
    state.accompanied = defaultAccompanied();
}

/**
 * Mutación para limpiar el buscador de la lista de los productos con beneficios menos la empresa.
 *
 * @param {*} state
 * @author Brandon Torres
 */
export function resetFilterCompany(state) {
    // Conserva la empresa
    const company_id = state.filterBenefits.company_id;

    // Limpia la data
    Object.assign(state.filterBenefits, defaultFilterBenefits());
    state.productBenefits = defaultProductBenefits();
    state.accompanied = defaultAccompanied();

    // Asigna la empresa conservada
    state.filterBenefits.company_id = company_id;
}

/**
 * Mutación para paginar los productos con beneficio.
 *
 * @param {*} state
 * @author Brandon Torres
 */
export function setPerPage(state, perPage) {
    state.filterBenefits.page = 1;
    state.filterBenefits.limit = perPage;
}

/**
 * Mutación para cambiar de pagina de los productos con beneficio.
 *
 * @param {*} state
 * @author Brandon Torres
 */
export function setPage(state, page) {
    state.filterBenefits.page = page;
}
